import React from 'react';

const HomeMessageInbox = ({ message, onPostMessage }) => {
    return (
      <div id="inbox-message" className="col-sm-12">
        <div className="heading-golfer">
          <h4>Message Preview</h4>
        </div>
        <div className="msg-preview-section">
          <div className="home-preview-box">
            <div id="msgheader">
              <h2><b><span className="msg-label">Subject:</span> {message?.subject || ""}</b></h2>
            </div>
            <div id="msg">
              {message?.message || ""}
            </div>
            <div className="home-post-wrap">
              <a href="#!" onClick={onPostMessage} className="reply-link ie-post-link green">
                Post a Message
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }

export default HomeMessageInbox
